<div class="wrap">
  <h1 *ngIf="!show">Réinitialisation du mot de passe</h1>
  <h1 *ngIf="show">Mot de passe modifié</h1>
  <form [formGroup]="resetPasswordByMail" (ngSubmit)="onSubmit()" *ngIf="!show">
    <div class="new_password">
      <label for="newPassword"><span>Nouveau</span> mot de passe</label>
      <input type="password" formControlName="newPassword"
        matTooltip="Minimum huit caractères, au moins une lettre et un chiffre"
        (input)="isInactive($event.target.value)">
    </div>
    <div class=" confirm_password">
      <label for="confirmPassword"><span>Confirmer</span> mot de passe</label>
      <input type="password" formControlName="confirmPassword" (input)="isInactive($event.target.value)">
    </div>
    <button [disabled]="loading" [ngClass]="{inactive: !inactive}">Confirmer</button>
    <p class="error" *ngIf="showError">
      Votre mot de passe est incorrect
    </p>
  </form>
  <div class="validation" *ngIf="show">
    <div class="validation_mail">
      <div class="check">
        <span class="icon-line line-tip"></span>
        <span class="icon-line line-long"></span>
        <div class="icon-circle"></div>
        <div class="icon-fix"></div>
      </div>
    </div>
    <p>Votre mot de passe a bien été modifié</p>
    <p class="redirection">Redirection en cours <span>.</span><span>.</span><span>.</span> </p>
  </div>
</div>